import {
  DEFAULT_SDK_CONFIG,
  type NormalizedSDKConfig,
  type SDKConfig,
  type SDKMountMode,
} from '../../../lib/embed-contracts/sdk-config'

function resolveMountMode(config: SDKConfig): SDKMountMode {
  if (config.mountMode) return config.mountMode
  return config.container ? 'inline' : 'floating'
}

function resolveContainer(container: SDKConfig['container'], mountMode: SDKMountMode) {
  if (typeof document === 'undefined') return null
  if (mountMode === 'floating') return document.body
  if (!container) return document.body
  if (typeof container === 'string') return document.querySelector<HTMLElement>(container)
  return container
}

export function normalizeSDKConfig(config: SDKConfig = {}): NormalizedSDKConfig {
  const mountMode = resolveMountMode(config)

  return {
    ...DEFAULT_SDK_CONFIG,
    ...config,
    extData: config.extData ?? DEFAULT_SDK_CONFIG.extData,
    resize: config.resize ?? DEFAULT_SDK_CONFIG.resize,
    autoShow: config.autoShow ?? (mountMode === 'inline'),
    mountMode,
    container: resolveContainer(config.container, mountMode),
  }
}